<template>
  <div class="plots-component">
    <div class="plot-count-block">
      <span
        >Минимальное количество площадок: <span>{{ circle_count }}</span></span
      ><br />
      <span
        >Всего площадок: <span>{{ plotList.length }}</span></span
      >
    </div>

    <div class="title">
      <span>Список площадок</span>
    </div>

    <div class="add-block-outer">
      <button
        @click="enableAddMode"
        v-if="!addMode"
        :disabled="!actLpoIsDraft"
      >
        Добавить площадку
      </button>
      <input type="button" value="Импорт координат"  :disabled="!actLpoIsDraft" onclick="document.getElementById('import-plots').click();" />
      <input type="file" accept=".xlsx" style="display:none;" id="import-plots" ref="import-plots" name="file" @change="importExcelPlots($event.target)"/>
      <div v-if="addMode" class="add-block-container">
        <AddBlock @close="disableAddMode" />
      </div>
    </div>

    <div v-if="!plotList.length" class="flex-item">
      <span>Площадки еще не добавлены</span>
    </div>

    <table v-else class="plots-table">
      <thead>
        <tr>
          <th>№</th>
          <th>Тип</th>
          <th>Широта</th>
          <th>Долгота</th>
          <th>Радиус, м</th>
          <th>Количество деревьев</th>
          <th>Площадка</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(plot, plot_i) in plotList" :key="plot.id">
          <template v-if="plot_i !== editedPlotNum">
            <td @contextmenu.prevent="openModalTrees1(plot)">{{ plot.num }}</td>
            <td>Круговая площадка</td>
            <td>
              {{
                plot.points && plot.points.length ? Number(plot.points[0].lat).toFixed(6) : null
              }}
            </td>
            <td>
              {{
                plot.points && plot.points.length ? Number(plot.points[0].lon).toFixed(6) : null
              }}
            </td>
            <td>{{ plot.radius_width }}</td>
            <td>
              {{ plot.trees_count }}
              <button @click="openModalTrees1(plot)">открыть список</button>
            </td>
            <td>
              <button
                @click="enableEditMode(plot, plot_i)"
                :disabled="!actLpoIsDraft"
              >
                Редактировать
              </button>
              <button @click="rmPlot(plot)" :disabled="!(actLpoIsDraft && recountIsOpen) && (!recountIsOpen && plot.trees_count > 0)">
                удалить
              </button>
            </td>
          </template>
          <template v-else>
            <td colspan="20">
              <EditBlock @close="disableEditMode" :plot="editedPlot" />
            </td>
          </template>
        </tr>
      </tbody>
    </table>

    <button
      class="toggle-recount-btn"
      v-if="plotList.length"
      @click="tggleRecount"
      :disabled="!actLpoIsDraft"
    >
      {{
        recountIsOpen
          ? "Перейти к внесению данных о модельных деревьях для установления разряда высот"
          : "Разблокировать перечет для редактирования"
      }}
    </button>

    <TreesModal
      :isOpen.sync="treesModalIsOpen"
      :preselectedPlot="selectedPlot"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import AddBlock from "./Recount__plotsCircleAdd";
import EditBlock from "./Recount__plotsCircleEdit";

import TreesModal from "./Recount__trees/TreesModal";

export default {
  name: "PlotsCircle",
  components: {
    AddBlock,
    EditBlock,

    TreesModal,
  },
  data: () => ({
    addMode: false,

    editedPlotNum: -1,
    editedPlot: null,

    selectedPlot: null,

    treesModalIsOpen: false,
  }),
  computed: {
    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },

    lpo() {
      return this.$store.state.selectedLpo.lpo;
    },

    ...mapState("selectedLpo/recount", {
      plotList: (state) => state["plotList"],
      treeList: (state) => state["treeList"],
      circle_count: (state) => state["circleCount"],
    }),

    ...mapGetters("selectedLpo/recount", ["recountIsOpen"]),
  },
  methods: {
    openModalTrees1(plot) {
      this.selectedPlot = plot;
      this.treesModalIsOpen = true;
    },

    enableAddMode() {
      this.addMode = true;
    },

    disableAddMode() {
      this.addMode = false;
    },

    enableEditMode(plot, plot_i) {
      this.editedPlot = plot;
      this.editedPlotNum = plot_i;
    },
    disableEditMode() {
      this.editedPlotNum = -1;
      this.editedPlot = null;
    },

    rmPlot(plot) {
      if (+plot.trees_count) {
        const confirmation = confirm("Удалить площадку?");
        if (!confirmation) {
          return;
        }
      }

      this.removePlot(plot).then((res) => {
        this.updatePlotList(this.lpo.lpo_id);
      });
    },

    async tggleRecount() {
      const LayerIsCorrect = await this.checkIsLayerCorrect();

      if (this.recountIsOpen && LayerIsCorrect?.is_correct === "f") {
        this.$toast.add({
          severity: "warn",
          detail:
            "Условия для выделения второго яруса не выполнены (полнота менее 0,3)!",
          life: 10000,
        });
        return;
      }

      if (this.recountIsOpen && +this.plotList.length < +this.circle_count) {
        // console.log('not enough plot');
        this.$toast.add({
          severity: "warn",
          detail: `Необходимо площадок: ${+this.circle_count}`,
          life: 5000,
        });
        return;
      }

      this.toggleRecount(this.lpo.lpo_id).then((res) => {
        this.updatePlotList(this.lpo.lpo_id).then((res) => {
          // this.getCircleCount();
        });
      });
    },

    ...mapActions("selectedLpo/recount", [
      "removePlot",
      "updatePlotList",
      "toggleRecount",
      "getCircleCount",
      "checkIsLayerCorrect",
      "importExcelPlots"
    ]),
  },
  created() {
    this.getCircleCount();
  },
};
</script>

<style scoped>
.plot-count-block {
  margin-bottom: 1rem;
}

.title {
  font-size: 1rem;
  font-weight: bold;
  font-style: italic;
  margin-bottom: 10px;
}

.add-block-outer {
  margin-bottom: 10px;
}

.plots-table {
}

.plots-table th {
  border-bottom: 2px solid black;
  font-weight: bold;
  padding: 6px 20px;
}
.plots-table td {
  border-bottom: 1px solid black;
  padding: 8px;
  text-align: center;
  vertical-align: middle;
}

.toggle-recount-btn {
  margin-top: 20px;
}
</style>
